module.exports = __webpack_public_path__ + "static/2-71db53d72c64221ff7f12dd80bad1610.png";